<template>
	<AceEditor
		:code="form_string"
		@input="onEditForm($event)"
		:readonly="false"
		language="json"
		theme="monokai"
		width="100%"
		height="76vh">
	</AceEditor>
</template>

<script>
import AceEditor from '@/components/ace_editor.vue'
export default {
	props: [ 'form' ],
	components: {
		AceEditor
	},
	data () {
		return {
			form_string: ''
		}
	},
	methods: {
		onEditForm (form) {
			this.form_string = form
			try {
				let form_obj = JSON.parse(form)
				this.form.parameters = form_obj
			} catch (error) {
				console.log(error)
			}
		}
	},
	mounted () {
		if (this.form.parameters) {
			try {
				this.form_string = JSON.stringify(this.form.parameters, null, 2)
			} catch (error) {
				console.log(error)
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.form
	border-top: 0.5px solid var(--v-background-base)
	border-bottom: 0.5px solid var(--v-background-base)
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/forms/launcher_form_raw.vue